<template>
    <div>
        <div class="content w1200">
            <div class="left">
                <div class="title">彩票导航</div>
                <div>
                    <div class="tit">指标考核</div>
                    <div class="cont sky" style="grid-template-columns: repeat(3, 1fr);">
                        <span @click="openInNewTab('/ssddt',1);">缩水大厅</span>
                        <span @click="openInNewTab('/ssdgw',2);">缩水单冠王</span>
                        <span @click="openInNewTab('/sdssxb',3);">十大学霸</span>
                        <span @click="openInNewTab('/hxwysz',4);">海选万元实战单</span>
                    </div>
                </div>
                <div>
                    <div class="tit">跳蚤市场</div>
                    <div class="cont sky">
                        <span @click="openInNewTab('/excel',4);">EXCEL技巧师大厅</span>
                        <span @click="openInNewTab('/suoshuiruanjian',5)">缩水软件特区</span>
                    </div>
                </div>
                <div>
                    <div class="tit">帮扶中心</div>
                    <div class="cont sky">
                        <span @click="openInNewTab('/sttzzbfzx',6);">投注站申请帮扶</span>
                        <span @click="openInNewTab('/sttzzbfzx',6);">实战超市</span>
                        <span @click="openInNewTab('/sttzzbfzx',6);">众筹招股大厅</span>
                        <span @click="openInNewTab('/sttzzbfzx',6);">彩票代表海选</span>
                    </div>
                </div>
                <div>
                    <div class="tit">申请入住</div>
                    <div class="cont sky">
                        <span @click="openInNewTab('/personalCenter/hangjiaguanli/apply_sss',null)">缩水师申请</span>
                        <!-- <span @click="$router.push('/personalCenter/tzz_bf/cp_tzz_sq_bf')">彩票投注站申请</span> -->
                        <span @click="openInNewTab('/personalCenter/tzz_bf/cp_tzz_sq_bf',null);">彩票投注站申请</span>

                        <span @click="openInNewTab('','')">技巧师申请</span>
                        <span @click="openInNewTab('','')">软件交易师申请</span>

                    </div>
                </div>
            </div>
            <div class="cont">
                <el-carousel style="text-align: center; font-size: 50px;height: 400px;">
                    <el-carousel-item v-for="(item,index) in banner" :key="index" style="height: 400px">
                        <el-image style="width: 100%; height: 100%;border-radius:0;" :src="item.img" fit="fit" @click="gotoPage(item)"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="right">
                <div class="rg_one">
                    <div class="user" @click="$router.push('/personalCenter/userinfo/yhzx')"><b>{{vuex_userInfo.nickName || ''}}</b> 欢迎您</div>
                    <div class="shrinkRecharge" @click="$router.push('/personalCenter/chongzhihetixian/suobichongzhi')">
                        <span>缩币充值</span>
                    </div>
                </div>
                <div class="cont">
                    <div class="nav">
                        <span v-for="(item, index) in notice_help.nav.arr" :key="index" :class="{active: notice_help.nav.active == index}" @click="notice_help.nav.active = index;getHelp_notice(index)">{{ item }}</span>
                    </div>
                    <div class="list">
                        <template v-if="notice_help.nav.active == 0">
                            <div v-for="(item,index) in notice_help.noticeList" :key="index" @click="gotoArticle_details(item,'notice')">
                                <div>{{item.noticeTitle}}</div>
                                <span style="width: 100px; text-align: right;">{{ item.createTime.substring(2,10) }}</span>
                            </div>
                        </template>
                        <template v-if="notice_help.nav.active == 1">
                            <div v-for="(item,index) in notice_help.helpList" :key="index" @click="gotoArticle_details(item,'help')">
                                <div>{{item.title}}</div>
                                <span>{{ item.createTime.substring(2,10) }}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <!-- <div class="btn" v-if="!vuex_userInfo.nickName">
                    <div @click="$router.push('/login')">登录</div>
                    <div @click="$router.push('/login/register')">注册</div>
                    <div @click="$router.push('/login/forgetPassword')">
                        忘记密码
                    </div>
                </div> -->
            </div>
        </div>

        <ssq></ssq>
        <dlt></dlt>
        <fcsd></fcsd>
        <pls></pls>

        <img src="@/assets/indexBottom.png" alt="" class="w1200" style="margin: 20px auto; display: block" />

        <div class="dibudaxiang">
            <span @click="openInNewTab('/ssddt',1)">缩水单大厅</span>
            <span @click="openInNewTab('/excel',4)">EXCEL转场</span>
            <span @click="openInNewTab('/suoshuiruanjian',5)">缩水软件特区</span>
            <span @click="openInNewTab('/sttzzbfzx',6)">投注站帮扶中心</span>
        </div>

    </div>
</template>

<script>
import ssq from "./template/ssq.vue";
import dlt from "./template/dlt.vue";
import fcsd from "./template/fcsd.vue";
import pls from "./template/pls.vue";

import { bannerApi, help, notice } from '@/api/home/index'

export default {
    components: { ssq, dlt, fcsd, pls, },
    data () {
        return {
            banner: [],
            notice_help: {
                nav: {
                    active: 0,
                    arr: ["网站公告", "帮助中心"],
                },
                noticeList: [],
                helpList: [],
            },
        };
    },
    mounted () {
        this.getBanner()
        this.getHelp_notice()
    },
    methods: {
        openInNewTab (path, menuActiveIndex = null) {

            if (menuActiveIndex === '') { return }

            this.$vuex('vuex_menuActiveIndex', menuActiveIndex)

            const env = process.env.NODE_ENV;
            let obj = {
                development: 'http://localhost:8080', // 本地开发地址
                production: process.env.VUE_APP_BASE_API, // 线上地址
            }

            const fullUrl = `${obj[env]}#${path}`;
            window.open(fullUrl, '_blank');
        },
        getBanner () {
            bannerApi().then(res => {
                let db = res.rows.filter(item => item.status == 0);
                let baseUrl = process.env.VUE_APP_BASE_API + '/stage-api';
                db.forEach(item => item.img = baseUrl + item.img);
                this.banner = db
            })
        },
        gotoPage (item) {
            window.open(item.link, '_blank')
        },

        getHelp_notice (index = 0) {

            if (index == 0) {
                notice(index).then(res => {
                    this.notice_help[index == 0 ? 'noticeList' : 'helpList'] = res.rows.splice(0, 9)
                })
            } else {
                help().then(res => {
                    this.notice_help[index == 0 ? 'noticeList' : 'helpList'] = res.rows.splice(0, 9)
                })
            }

        },

        gotoArticle_details (item, type) {
            // console.log('ss',JSON.parse(JSON.stringify(item)));
            let id = type == 'notice' ? item.noticeId : item.id;
            // console.log('id',id);
            // this.$vuex('vuex_articleDetails', item)
            this.$router.push({
                name: 'article_details',
                query: { id, type }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;

    > div {
        &.left,
        &.right {
            width: 300px;
            .btn {
                display: flex;
                div {
                    width: 33%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    text-align: center;
                    padding: 10px 0;
                    cursor: pointer;
                }
            }
        }
        &.cont {
            flex: 1;
            background: rgba(0, 0, 0, 0.2);
        }

        &.left {
            .title {
                padding: 20px;
                padding-bottom: 10px;
                font-size: 20px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            }
            > div:nth-child(n + 2) {
                padding: 0 20px;
                .tit {
                    font-size: 20px;
                    padding: 15px 0 5px;
                }
                .cont {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    span {
                        padding: 2px 0;
                        font-size: 14px;
                        cursor: pointer;
                        width: max-content;

                        transform-origin: center;
                        transition: transform 0.5s;

                        position: relative;
                        color: #3072cd;

                        &:hover {
                            transform: scale(1.5);
                            font-weight: bold;
                            // text-decoration: underline;
                            &::after {
                                width: 100%;
                                left: 0%;
                            }
                        }
                        &:not(:hover) {
                            transform: scale(1);
                            font-weight: inherit;

                            &::after {
                                width: 0%;
                                left: 50%;
                            }
                        }

                        &::after {
                            content: '';
                            display: block;
                            border-bottom: 3px solid #3072cd;
                            width: 0%;
                            position: absolute;
                            left: 50%;
                            transition: width 0.5s linear, left 0.5s linear;
                        }
                    }
                }
            }
        }
        &.right {
            padding: 10px;

            .rg_one {
                display: flex;
                > div {
                    cursor: pointer;
                    height: 50px;
                    line-height: 50px;
                    flex: 1;
                    text-align: center;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    position: relative;
                    &.user {
                        background-color: #f4ce98;
                        color: #bd392f;
                    }
                    &.shrinkRecharge {
                        // background-color: #347CAF;
                        background-color: red;
                        color: #fff;
                        flex: 0.4;
                        transition: padding 0.5s linear;
                        &:hover {
                            padding: 0 30px;
                            &::after {
                                width: 100%;
                                left: 0%;
                            }
                        }
                        &:not(:hover) {
                            padding: 0 0px;
                            font-weight: inherit;
                            &::after {
                                width: 0%;
                                left: 50%;
                            }
                        }

                        &::after {
                            content: '';
                            display: block;
                            border-bottom: 3px solid #3072cd;
                            width: 0%;
                            position: absolute;
                            left: 50%;
                            transition: width 0.5s linear, left 0.5s linear;
                        }
                    }
                }
            }

            .cont {
                margin: auto;
                // border: 1px solid red;
                display: flex;
                flex-direction: column;
                align-items: center;
                .nav {
                    width: 65%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 0px 0 5px;
                    color: #347caf;
                    font-weight: bold;
                    span {
                        cursor: pointer;
                        font-size: 20px;
                        border-bottom: 3px solid rgba(0, 0, 0, 0.1);
                        padding: 10px 0;
                        text-align: center;
                        &.active {
                            border-bottom: 3px solid #347caf;
                        }
                    }
                }
                .list {
                    width: 95%;
                    div {
                        display: flex;
                        justify-content: space-between;
                        // padding: 10px;
                        line-height: 30px;
                        cursor: pointer;
                        div {
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;
                            display: block;

                            &:hover {
                                transition: transform 0.5s;
                                transform: scale(1.1);
                                font-weight: bold;
                                transform-origin: left;
                            }
                            &:not(:hover) {
                                transition: transform 0.5s;
                                transform: scale(1);
                                font-weight: inherit;
                                transform-origin: left;
                            }
                        }
                        span {
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }
}
.dibudaxiang {
    width: 930px;
    margin: 50px auto 80px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    span {
        white-space: nowrap;
        padding: 15px 50px;
        border: 2px solid #3d82b2;
        color: #3d82b2;
        font-weight: bold;
        border-radius: 10px;
    }
}
</style>